import { PuzzleAccount, useDisconnect } from '@puzzlehq/sdk';
import { useNavigate } from '@tanstack/react-router';
import { shortenAddress } from 'jigsaw';
import { BiWalletAlt } from 'react-icons/bi';
import { Route as index_route } from '@src/routes/index.js';
import {
  HStack,
  theme,
  Text,
  Dialog,
  DialogTrigger,
  DialogContent,
  VStack,
  DialogHeader,
  DialogTitle,
  DialogOverlay,
  DialogClose,
  DialogFooter,
  Button,
} from 'ui_2';

export const SelectedAccount = ({ account }: { account: PuzzleAccount }) => {
  const { disconnect, loading } = useDisconnect();
  const navigate = useNavigate();

  return (
    <Dialog>
      <DialogOverlay className='bg-gray-900/40' />
      <DialogTrigger asChild>
        <HStack className='items-center justify-between gap-2 rounded-full border border-[#435D63] bg-[#104049] px-4'>
          <BiWalletAlt color={theme.colors.aqua} size={24} />
          <Text color='aqua' font='lg' family='space'>
            {shortenAddress(account.address)}
          </Text>
        </HStack>
      </DialogTrigger>
      <DialogContent
        aria-describedby='account-description'
        className='w-4/5 max-w-[400px] rounded-[10px] border border-aqua bg-[#13252c]'
        showOverlay={false}
      >
        <DialogHeader>
          <DialogTitle className='text-center text-aqua'>
            <Text family='space' color='aqua' id='account-description'>
              Profile
            </Text>
          </DialogTitle>
          <DialogClose className='text-aqua' />
        </DialogHeader>
        <VStack>
          <Text family='space' font='sm' color='aqua'>
            Address
          </Text>
          <div
            style={{ wordBreak: 'break-word' }}
            className='w-full rounded-[10px] bg-[#152C36]'
          >
            <Text className='p-2' color='aqua' family='space'>
              {account.address}
            </Text>
          </div>
        </VStack>
        <DialogFooter className='w-full'>
          <HStack className='w-full px-4'>
            <Button
              variant='mysteryCitySecondary'
              fullWidth
              disabled={loading}
              onClick={() => {
                disconnect();
                navigate({ to: index_route.to });
              }}
            >
              Disconnect Wallet
            </Button>
          </HStack>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
